import React from 'react'
import Wave from 'react-wavify'

const ThinkContact = () => {
  return (
    <div className='relative overflow-hidden sm:top-[-30px] top-[-30px] z-20 '>
      <Wave fill='white'
        paused={false}
        style={{ display: 'flex' }}
        options={{
          height: 20,
          amplitude: 25,
          speed: 0.3,
          points: 5
        }}
        className='relative min-w-[1920px] sm:h-[40px] h-[40px] '
      />

      <div className='text-center sm:mt-11 mt-8 '>
        <h2 className=" md:text-[40px] sm:text-[26px] sx:text-[25px] text-[20px] font-[700] text-theme_dark text-center">WHAT ARE YOU THINKING? LET US KNOW!</h2>
        <div className='flex justify-center mt-5'>
          <div className='lg:w-2/5 md:w-1/2 sm:w-3/5 text-center sm:px-0 px-2'>
            <p className='text-txt_color sm:text-[18px] text-[16px] 3xl:px-11 3xl:mx-[70px]'>We would be glad to hear from you.
              Please fill in the form below or mail us your requirements at <a href="mailto:Info@kalathiyainfotech.com" className="hover:underline">Info<span className='text-theme_dark font-[700]'>@kalathiyainfotech.com</span></a> </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ThinkContact
